export default __webpack_public_path__ + "static/media/chain-okx.e4b6005c.svg";